// import React from 'react'
import styles from './ProjectInfo.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectInfo = ({ props }) => {
  return (
    <>
      <div
        className={classnames(isMobile ? [styles.description, styles.mobile] : [styles.description])}
        dangerouslySetInnerHTML={{ __html: props.description }}
      />
      <dl className={classnames(isMobile ? [styles.info, styles.mobile] : [styles.info])}>
        <div>
          <dt>Год:</dt>
          <dd>{props.year}</dd>
        </div>

        {props.customer && (
          <div>
            <dt>Заказчик:</dt>
            <dd>{props.customer}</dd>
          </div>
        )}

        {props.status && (
          <div>
            <dt>Статус:</dt>
            <dd>{props.status === 'concept' ? 'Концепция' : 'Проектно-сметная документация'}</dd>
          </div>
        )}

        <div>
          <dt>Место:</dt>
          <dd>{props.place}</dd>
        </div>
      </dl>
    </>
  );
};

export default ProjectInfo;
